import React from "react";

const variantClasses = {
  primary:
    "bg-[#4f46e5] text-white shadow-[0_10px_20px_rgba(79,70,229,0.25)] hover:bg-[#4338ca] focus-visible:outline-[#4f46e5]",
  secondary:
    "bg-white text-slate-700 border border-slate-200 hover:border-slate-300 hover:text-slate-900 focus-visible:outline-slate-400",
  ghost: "bg-transparent text-slate-600 hover:text-slate-900",
};

const sizeClasses = {
  sm: "h-9 px-3 text-sm",
  md: "h-11 px-4 text-sm",
  lg: "h-12 px-6 text-base",
};

const Button = ({
  children,
  className = "",
  type = "button",
  variant = "primary",
  size = "lg",
  ...props
}) => {
  return (
    <button
      type={type}
      className={[
        "rounded-lg font-semibold transition cursor-pointer disabled:cursor-not-allowed disabled:opacity-60 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2",
        variantClasses[variant] || variantClasses.primary,
        sizeClasses[size] || sizeClasses.lg,
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
